var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group mb-2 cursor-pointer place-input"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"data-toggle":"tooltip","title":_vm.$t('todos.location')}},[_c('i',{staticClass:"icon-location4"})])]),_c('places',{staticClass:"form-control form-control-lg bg-white px-2 algolia-form-control",attrs:{"options":{
      type:'address',
      templates: {
        value: function(suggestion) {
          return suggestion.name;
        }
      }},"placeholder":_vm.$t('todos.location')},on:{"change":function($event){return _vm.positionChange($event)}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }